import { RatePlan, RatePlanCharge } from '../ratePlan';

export interface RatePlanWithAmendment {
  id: RatePlan['id'];
  ratePlanCharges: Array<Pick<RatePlanCharge, 'originalChargeId' | 'quantity'>>;
}
export const hasRatePlanQtyChangeAmendmends = (
  latestRateplans: RatePlanWithAmendment[],
  ratePlan: RatePlanWithAmendment,
) =>
  latestRateplans.some((latestRatePlan) => {
    if (latestRatePlan.id !== ratePlan.id) {
      return false;
    }
    return ratePlan.ratePlanCharges.some((charge) => {
      return latestRatePlan.ratePlanCharges.some((latestCharge) => {
        return (
          charge.originalChargeId === latestCharge.originalChargeId &&
          charge.quantity !== latestCharge.quantity
        );
      });
    });
  });
